export default "__VITE_ASSET__B2eooFnE__"